var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoToFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89995 14.1846C6.10161 14.1846 5.32228 13.8809 4.71402 13.2924C3.51651 12.0775 3.51651 10.1223 4.71402 8.92635L9.94125 3.70605H1.00743C0.437187 3.70605 0 4.16164 0 4.71215V16.9941C0 17.5636 0.456195 18.0002 1.00743 18.0002H13.2867C13.8569 18.0002 14.2941 17.5446 14.2941 16.9941V8.07212L9.08589 13.2924C8.47763 13.8809 7.69829 14.1846 6.89995 14.1846Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9745 0H10.8934C10.3423 0 9.88621 0.456618 9.88621 1.00836C9.88621 1.56011 10.3423 2.01673 10.8934 2.01673H14.5421L6.12352 10.4451C5.72445 10.8447 5.72445 11.4725 6.12352 11.8721C6.31356 12.0623 6.57961 12.1765 6.84566 12.1765C7.1117 12.1765 7.35875 12.0813 7.56779 11.8721L15.9863 3.44366V7.0966C15.9863 7.64835 16.4424 8.10496 16.9935 8.10496C17.5446 8.10496 18.0007 7.64835 18.0007 7.0966V1.00836C17.9817 0.456618 17.5256 0 16.9745 0Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToFlow);
export default __webpack_public_path__ + "static/media/go-to-flow.ffcdca5fb2dad8430a3d587772f71ed2.svg";
export { ForwardRef as ReactComponent };